/* eslint-disable react/display-name */
import { makeStyles } from '@mui/styles';
import { blue } from 'apollo-react/colors';
import IconButton from 'apollo-react/components/IconButton';
import RadioUnchecked from 'apollo-react-icons/RadioUnchecked';
import React from 'react';

const useStyles = makeStyles({
  iconContainer: {
    width: 32,
  },
  iconButton: {
    marginRight: 4,
  },
  icon: {
    '&:hover': { color: blue },
  },
});

const SingleSelectCell = (handleSelect, columns) => {
  const classes = useStyles();
  return ({ row }) => (
    <div className={classes.iconContainer}>
      <IconButton
        className={classes.iconButton}
        onClick={() => {
          handleSelect(row, columns);
        }}
      >
        <RadioUnchecked className={classes.icon} ui-ta="radio-unchecked-icon" />
      </IconButton>
    </div>
  );
};

export default SingleSelectCell;
